/**
 * @generated SignedSource<<a03de241bb1bd1c19bc864ceca1ff10d>>
 * @relayHash aea1ae07f1409bc8a70fbc4d768d86d9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aea1ae07f1409bc8a70fbc4d768d86d9

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueViewerViewQuery$variables = {
  allowedOwner?: string | null;
  number: number;
  owner: string;
  repo: string;
};
export type IssueViewerViewQuery$data = {
  readonly repository: {
    readonly issue: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueViewerView">;
    };
  } | null;
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueViewerViewer">;
  };
};
export type IssueViewerViewQuery = {
  response: IssueViewerViewQuery$data;
  variables: IssueViewerViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allowedOwner"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "number"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repo"
},
v4 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "repo"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "number",
    "variableName": "number"
  }
],
v6 = {
  "kind": "Variable",
  "name": "allowedOwner",
  "variableName": "allowedOwner"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v10 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v11 = [
  (v7/*: any*/)
],
v12 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v22 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v25 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "issueType",
    "storageKey": null
  },
  (v18/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isEnabled",
    "storageKey": null
  },
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slashCommandsEnabled",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v37 = {
  "kind": "Literal",
  "name": "unfurlReferences",
  "value": true
},
v38 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v39 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v18/*: any*/),
  (v20/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "UserEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v39/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oid",
      "storageKey": null
    },
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "associatedPullRequests",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v46 = {
  "kind": "Literal",
  "name": "visibleEventsOnly",
  "value": true
},
v47 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  },
  (v46/*: any*/)
],
v48 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasReacted",
  "storageKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReadUserContentEdits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastEditedAt",
      "storageKey": null
    }
  ],
  "type": "Comment",
  "abstractKey": "__isComment"
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v7/*: any*/),
    (v36/*: any*/),
    {
      "alias": null,
      "args": [
        (v37/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "bodyHTML",
      "storageKey": "bodyHTML(unfurlReferences:true)"
    },
    (v49/*: any*/),
    (v29/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "authorAssociation",
      "storageKey": null
    },
    (v35/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanMinimize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSeeMinimizeButton",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSeeUnminimizeButton",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReport",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReportToMaintainer",
      "storageKey": null
    },
    {
      "alias": "isHidden",
      "args": null,
      "kind": "ScalarField",
      "name": "isMinimized",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minimizedReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v9/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v9/*: any*/),
            (v29/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        },
        (v19/*: any*/),
        (v27/*: any*/),
        (v21/*: any*/),
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        (v7/*: any*/),
        (v34/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionGroup",
      "kind": "LinkedField",
      "name": "reactionGroups",
      "plural": true,
      "selections": [
        (v50/*: any*/),
        {
          "alias": null,
          "args": (v41/*: any*/),
          "concreteType": "ReactorConnection",
          "kind": "LinkedField",
          "name": "reactors",
          "plural": false,
          "selections": (v17/*: any*/),
          "storageKey": "reactors(first:5)"
        },
        (v51/*: any*/)
      ],
      "storageKey": null
    },
    (v52/*: any*/)
  ],
  "type": "IssueComment",
  "abstractKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v9/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v10/*: any*/),
    (v9/*: any*/),
    (v20/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v15/*: any*/),
    (v31/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "closer",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v29/*: any*/),
            (v33/*: any*/),
            (v54/*: any*/)
          ],
          "type": "PullRequest",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v29/*: any*/),
            (v55/*: any*/),
            (v54/*: any*/)
          ],
          "type": "Commit",
          "abstractKey": null
        },
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    (v56/*: any*/)
  ],
  "type": "ClosedEvent",
  "abstractKey": null
},
v58 = [
  (v26/*: any*/),
  (v15/*: any*/),
  (v56/*: any*/)
],
v59 = {
  "kind": "InlineFragment",
  "selections": (v58/*: any*/),
  "type": "ReopenedEvent",
  "abstractKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v12/*: any*/),
    (v10/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/),
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Commit",
      "kind": "LinkedField",
      "name": "commit",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        (v29/*: any*/),
        (v55/*: any*/),
        (v54/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    (v15/*: any*/)
  ],
  "type": "ReferencedEvent",
  "abstractKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "source",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v12/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v26/*: any*/),
            (v32/*: any*/),
            (v29/*: any*/),
            (v33/*: any*/),
            (v31/*: any*/),
            (v54/*: any*/)
          ],
          "type": "Issue",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "issueDatabaseId",
              "storageKey": null
            },
            (v32/*: any*/),
            (v29/*: any*/),
            (v33/*: any*/),
            (v30/*: any*/),
            (v45/*: any*/),
            (v62/*: any*/),
            (v54/*: any*/)
          ],
          "type": "PullRequest",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "willCloseTarget",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referencedAt",
      "storageKey": null
    },
    (v26/*: any*/)
  ],
  "type": "CrossReferencedEvent",
  "abstractKey": null
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/),
    (v15/*: any*/),
    (v26/*: any*/)
  ],
  "type": "MentionedEvent",
  "abstractKey": null
},
v65 = [
  (v9/*: any*/),
  (v7/*: any*/)
],
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "ReactionGroup",
  "kind": "LinkedField",
  "name": "reactionGroups",
  "plural": true,
  "selections": [
    (v50/*: any*/),
    {
      "alias": null,
      "args": (v41/*: any*/),
      "concreteType": "ReactorConnection",
      "kind": "LinkedField",
      "name": "reactors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReactorEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v65/*: any*/),
                  "type": "User",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v65/*: any*/),
                  "type": "Bot",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v65/*: any*/),
                  "type": "Organization",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v65/*: any*/),
                  "type": "Mannequin",
                  "abstractKey": null
                },
                (v12/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v16/*: any*/)
      ],
      "storageKey": "reactors(first:5)"
    },
    (v51/*: any*/)
  ],
  "storageKey": null
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v66/*: any*/),
    (v7/*: any*/)
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "Project",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v29/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColumnName",
  "storageKey": null
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/),
    (v56/*: any*/),
    (v68/*: any*/),
    (v69/*: any*/),
    (v26/*: any*/)
  ],
  "type": "AddedToProjectEvent",
  "abstractKey": null
},
v71 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/),
    (v26/*: any*/),
    (v56/*: any*/),
    (v68/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousProjectColumnName",
      "storageKey": null
    },
    (v69/*: any*/)
  ],
  "type": "MovedColumnsInProjectEvent",
  "abstractKey": null
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/),
    (v26/*: any*/),
    (v56/*: any*/),
    (v68/*: any*/),
    (v69/*: any*/)
  ],
  "type": "RemovedFromProjectEvent",
  "abstractKey": null
},
v73 = [
  (v15/*: any*/),
  (v26/*: any*/),
  (v56/*: any*/)
],
v74 = {
  "kind": "InlineFragment",
  "selections": (v73/*: any*/),
  "type": "SubscribedEvent",
  "abstractKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": (v73/*: any*/),
  "type": "UnsubscribedEvent",
  "abstractKey": null
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockReason",
      "storageKey": null
    },
    (v56/*: any*/)
  ],
  "type": "LockedEvent",
  "abstractKey": null
},
v77 = {
  "kind": "InlineFragment",
  "selections": (v58/*: any*/),
  "type": "UnlockedEvent",
  "abstractKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": (v58/*: any*/),
  "type": "PinnedEvent",
  "abstractKey": null
},
v79 = {
  "kind": "InlineFragment",
  "selections": (v58/*: any*/),
  "type": "UnpinnedEvent",
  "abstractKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v82 = [
  (v26/*: any*/),
  (v15/*: any*/),
  (v56/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Label",
    "kind": "LinkedField",
    "name": "label",
    "plural": false,
    "selections": [
      (v80/*: any*/),
      (v18/*: any*/),
      (v81/*: any*/),
      (v7/*: any*/),
      (v54/*: any*/)
    ],
    "storageKey": null
  }
],
v83 = {
  "kind": "InlineFragment",
  "selections": (v82/*: any*/),
  "type": "LabeledEvent",
  "abstractKey": null
},
v84 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v15/*: any*/),
    (v56/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousTitle",
      "storageKey": null
    }
  ],
  "type": "RenamedTitleEvent",
  "abstractKey": null
},
v85 = {
  "kind": "InlineFragment",
  "selections": (v82/*: any*/),
  "type": "UnlabeledEvent",
  "abstractKey": null
},
v86 = [
  (v9/*: any*/)
],
v87 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v20/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v86/*: any*/),
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v86/*: any*/),
          "type": "Mannequin",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v86/*: any*/),
          "type": "Organization",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v86/*: any*/),
          "type": "Bot",
          "abstractKey": null
        },
        (v12/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UnassignedEvent",
  "abstractKey": null
},
v88 = [
  (v13/*: any*/),
  (v9/*: any*/)
],
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v15/*: any*/),
    (v56/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v88/*: any*/),
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v88/*: any*/),
          "type": "Mannequin",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v88/*: any*/),
          "type": "Organization",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v88/*: any*/),
          "type": "Bot",
          "abstractKey": null
        },
        (v12/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AssignedEvent",
  "abstractKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v15/*: any*/),
    (v56/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "deletedCommentAuthor",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v9/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "CommentDeletedEvent",
  "abstractKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blockDuration",
      "storageKey": null
    },
    (v56/*: any*/),
    {
      "alias": "blockedUser",
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": (v65/*: any*/),
      "storageKey": null
    }
  ],
  "type": "UserBlockedEvent",
  "abstractKey": null
},
v92 = [
  (v26/*: any*/),
  (v15/*: any*/),
  (v56/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v29/*: any*/),
      (v7/*: any*/)
    ],
    "storageKey": null
  }
],
v93 = {
  "kind": "InlineFragment",
  "selections": (v92/*: any*/),
  "type": "MilestonedEvent",
  "abstractKey": null
},
v94 = {
  "kind": "InlineFragment",
  "selections": (v92/*: any*/),
  "type": "DemilestonedEvent",
  "abstractKey": null
},
v95 = [
  (v26/*: any*/),
  (v56/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v32/*: any*/),
          (v29/*: any*/),
          (v33/*: any*/),
          (v30/*: any*/),
          (v45/*: any*/),
          (v62/*: any*/),
          (v54/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v12/*: any*/)
    ],
    "storageKey": null
  }
],
v96 = {
  "kind": "InlineFragment",
  "selections": (v95/*: any*/),
  "type": "ConnectedEvent",
  "abstractKey": null
},
v97 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v56/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "fromRepository",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        (v29/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TransferredEvent",
  "abstractKey": null
},
v98 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v56/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v29/*: any*/),
        (v18/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ConvertedNoteToIssueEvent",
  "abstractKey": null
},
v99 = {
  "kind": "InlineFragment",
  "selections": (v95/*: any*/),
  "type": "DisconnectedEvent",
  "abstractKey": null
},
v100 = [
  (v29/*: any*/),
  (v33/*: any*/)
],
v101 = [
  (v56/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "canonical",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": (v100/*: any*/),
        "type": "Issue",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v100/*: any*/),
        "type": "PullRequest",
        "abstractKey": null
      },
      (v12/*: any*/)
    ],
    "storageKey": null
  },
  (v26/*: any*/)
],
v102 = {
  "kind": "InlineFragment",
  "selections": (v101/*: any*/),
  "type": "MarkedAsDuplicateEvent",
  "abstractKey": null
},
v103 = {
  "kind": "InlineFragment",
  "selections": (v101/*: any*/),
  "type": "UnmarkedAsDuplicateEvent",
  "abstractKey": null
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v56/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Discussion",
      "kind": "LinkedField",
      "name": "discussion",
      "plural": false,
      "selections": [
        (v29/*: any*/),
        (v33/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ConvertedToDiscussionEvent",
  "abstractKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v29/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v106 = [
  (v15/*: any*/),
  (v56/*: any*/),
  (v105/*: any*/)
],
v107 = {
  "kind": "InlineFragment",
  "selections": (v106/*: any*/),
  "type": "AddedToProjectV2Event",
  "abstractKey": null
},
v108 = {
  "kind": "InlineFragment",
  "selections": (v106/*: any*/),
  "type": "RemovedFromProjectV2Event",
  "abstractKey": null
},
v109 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/),
    (v56/*: any*/),
    (v105/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "ProjectV2ItemStatusChangedEvent",
  "abstractKey": null
},
v110 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/),
    (v56/*: any*/),
    (v26/*: any*/)
  ],
  "type": "ConvertedFromDraftEvent",
  "abstractKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v113 = [
  "visibleEventsOnly"
],
v114 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 0
  },
  (v46/*: any*/)
],
v115 = [
  (v6/*: any*/),
  (v22/*: any*/)
],
v116 = {
  "alias": null,
  "args": (v115/*: any*/),
  "concreteType": "ProjectV2ItemConnection",
  "kind": "LinkedField",
  "name": "projectItemsNext",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2ItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v28/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectV2",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v32/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "template",
                  "storageKey": null
                },
                (v49/*: any*/),
                (v42/*: any*/),
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "Status"
                }
              ],
              "concreteType": null,
              "kind": "LinkedField",
              "name": "fieldValueByName",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v18/*: any*/)
                  ],
                  "type": "ProjectV2ItemFieldSingleSelectValue",
                  "abstractKey": null
                },
                (v12/*: any*/)
              ],
              "storageKey": "fieldValueByName(name:\"Status\")"
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        (v111/*: any*/)
      ],
      "storageKey": null
    },
    (v112/*: any*/)
  ],
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": (v115/*: any*/),
  "filters": [
    "allowedOwner"
  ],
  "handle": "connection",
  "key": "ProjectSection_projectItemsNext",
  "kind": "LinkedHandle",
  "name": "projectItemsNext"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "issue",
              "plural": false,
              "selections": [
                {
                  "args": [
                    (v6/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "IssueViewerView"
                }
              ],
              "storageKey": null
            },
            "action": "THROW",
            "path": "repository.issue"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IssueViewerViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isReadByViewer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v14/*: any*/),
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v14/*: any*/),
                    "type": "Bot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v14/*: any*/),
                    "type": "Mannequin",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTransferInProgress",
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueCommentConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v20/*: any*/),
                      (v9/*: any*/),
                      (v7/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": "IssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "issueTypes(first:10)"
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "securityPolicyUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contributingFileUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "codeOfConductFileUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibility",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanPush",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "titleHTML",
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanTransfer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerThreadSubscriptionFormAction",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TrackedIssueCompletion",
                "kind": "LinkedField",
                "name": "tasklistBlocksCompletion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v26/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "renderTasklistBlocks",
                    "value": true
                  },
                  (v37/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "bodyHTML",
                "storageKey": "bodyHTML(renderTasklistBlocks:true,unfurlReferences:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanComment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanClose",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanReopen",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v38/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "assignees",
                "plural": false,
                "selections": [
                  (v40/*: any*/)
                ],
                "storageKey": "assignees(first:20)"
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "participants",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": "participants(first:5)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanAssign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestone",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v32/*: any*/),
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progressPercentage",
                    "storageKey": null
                  },
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetMilestone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "IssueConnection",
                "kind": "LinkedField",
                "name": "trackedInIssues",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Issue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          (v33/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Repository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "trackedInIssues(first:10)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 25
                  }
                ],
                "concreteType": "LinkedBranchConnection",
                "kind": "LinkedField",
                "name": "linkedBranches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkedBranchEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkedBranch",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Ref",
                            "kind": "LinkedField",
                            "name": "ref",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v7/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Ref",
                                    "kind": "LinkedField",
                                    "name": "defaultBranchRef",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v7/*: any*/),
                                      (v43/*: any*/),
                                      (v44/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": (v11/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v44/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "linkedBranches(first:25)"
              },
              {
                "alias": null,
                "args": [
                  (v22/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "includeClosedPrs",
                    "value": true
                  }
                ],
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequestEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PullRequest",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v29/*: any*/),
                          (v33/*: any*/),
                          (v32/*: any*/),
                          (v30/*: any*/),
                          (v45/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Repository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v18/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v8/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
              },
              {
                "alias": "frontTimeline",
                "args": (v47/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v26/*: any*/)
                            ],
                            "type": "TimelineEvent",
                            "abstractKey": "__isTimelineEvent"
                          },
                          (v12/*: any*/),
                          (v48/*: any*/),
                          (v53/*: any*/),
                          (v57/*: any*/),
                          (v59/*: any*/),
                          (v61/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v67/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          (v77/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v87/*: any*/),
                          (v89/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          (v96/*: any*/),
                          (v97/*: any*/),
                          (v98/*: any*/),
                          (v99/*: any*/),
                          (v102/*: any*/),
                          (v103/*: any*/),
                          (v104/*: any*/),
                          (v107/*: any*/),
                          (v108/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v111/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v112/*: any*/)
                ],
                "storageKey": "timelineItems(first:15,visibleEventsOnly:true)"
              },
              {
                "alias": "frontTimeline",
                "args": (v47/*: any*/),
                "filters": (v113/*: any*/),
                "handle": "connection",
                "key": "Issue_frontTimeline",
                "kind": "LinkedHandle",
                "name": "timelineItems"
              },
              {
                "alias": null,
                "args": (v114/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v53/*: any*/),
                          (v12/*: any*/),
                          (v48/*: any*/),
                          (v57/*: any*/),
                          (v59/*: any*/),
                          (v61/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v67/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          (v77/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v87/*: any*/),
                          (v89/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          (v96/*: any*/),
                          (v97/*: any*/),
                          (v98/*: any*/),
                          (v99/*: any*/),
                          (v102/*: any*/),
                          (v103/*: any*/),
                          (v104/*: any*/),
                          (v107/*: any*/),
                          (v108/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v111/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "timelineItems(last:0,visibleEventsOnly:true)"
              },
              {
                "alias": null,
                "args": (v114/*: any*/),
                "filters": (v113/*: any*/),
                "handle": "connection",
                "key": "IssueBacksideTimeline_timelineItems",
                "kind": "LinkedHandle",
                "name": "timelineItems"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v66/*: any*/)
                ],
                "type": "Reactable",
                "abstractKey": "__isReactable"
              },
              (v52/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v38/*: any*/),
                    "concreteType": "LabelConnection",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v81/*: any*/),
                              (v18/*: any*/),
                              (v80/*: any*/),
                              (v24/*: any*/),
                              (v29/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v111/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v112/*: any*/)
                    ],
                    "storageKey": "labels(first:20)"
                  },
                  {
                    "alias": null,
                    "args": (v38/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "MetadataSectionAssignedLabels_labels",
                    "kind": "LinkedHandle",
                    "name": "labels"
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isNode"
                  }
                ],
                "type": "Labelable",
                "abstractKey": "__isLabelable"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v116/*: any*/),
                      (v117/*: any*/)
                    ],
                    "type": "Issue",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v116/*: any*/),
                      (v117/*: any*/),
                      (v49/*: any*/)
                    ],
                    "type": "PullRequest",
                    "abstractKey": null
                  }
                ],
                "type": "IssueOrPullRequest",
                "abstractKey": "__isIssueOrPullRequest"
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v39/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "aea1ae07f1409bc8a70fbc4d768d86d9",
    "metadata": {},
    "name": "IssueViewerViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6c5e4a7c030a6582a0cda39ead5b09ba";

export default node;
